module.exports = __webpack_public_path__ + "img/loading.3764e79b.gif";